export const PUMP_NONE_CODE = 'NONE';

export const PP_QTY_DEFAULT_VALUE = 'PP_QTY_DEFAULT_VALUE';
export const PP_ABD_MAX_VALUE = 'PP_ABD_MAX_VALUE';
export const PP_ABD_DEFAULT_VALUE = 'PP_ABD_DEFAULT_VALUE';
export const PP_PUMP_MED_VALUE = 'PP_PUMP_MED_VALUE';
export const PP_QTY_MAX_VALUE = 'PP_QTY_MAX_VALUE';
export const PP_QTY_MIN_VALUE = 'PP_QTY_MIN_VALUE';
export const PP_PUMP_MED_MULTIPLE_VALUE = 'PP_PUMP_MED_MULTIPLE_VALUE';
export const PUMP_PRIMER_MIX = 'pumpPrimerProduct';
export const PUMP_PRIMER_QUANTITY = 'primerQuantity';
export const PUMP_PRIMER_ARRIVAL_BEFORE_DELIVERY = 'primerArrivalBeforeDelivery';
export const PUMP_PRIMER_SLUMP = 'primerSlump';
export const PUMP_PRIMER_FEATURE = 'PUMP_PRIMER';
/**
 * Constants for define default value for unload type previous and after of catalog update
 * @deprecated @UNLOAD_TYPE_DEFAULT1 Initial definition for default value
 * @UNLOAD_TYPE_DEFAULT2 With catalog update 'DIRECT_FLOW' will be missing and new default value is 'TAILGATE'
 * We keep both values for avoid errors in case catalog update is not ready in all environments
 * TODO: Remove @UNLOAD_TYPE_DEFAULT1 when catalog update is done in  all environments
 */
export const UNLOAD_TYPE_DEFAULT1 = 'DIRECT_FLOW';
export const UNLOAD_TYPE_DEFAULT2 = 'TAILGATE';
